import React from "react";

const ImageSkeleton = ({ className = "h-48 w-full" }) => (
  <div className={`animate-pulse rounded-md bg-stone-300 ${className}`} />
);

export default ImageSkeleton;
